import { useTranslation } from "@opendash/core";
import { Card, Statistic } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useEffect, useState } from "react";
import { Ticket_Kanban_State_Current } from "../../../js/parsegenerated";
import { useDurationFormat } from "../hooks/useDurationFormat";

/**
 * MTTR (mean time to recovery or mean time to restore) is the average time it takes to recover from a product or system failure.
 */
export default observer(function MeantTimeToRecovery(props: {
  ticketEndStates: Ticket_Kanban_State_Current[];
}) {
  const t = useTranslation();
  const [mttr, setMttr] = useState(0);
  const mttrFormat = useDurationFormat(mttr);

  useEffect(() => {
    async function getMTTR() {
      // this is a very simple approach to calculate the mean time to recovery
      // it only checks when the ticket was created and when it was finished
      // it does not take into account if a ticket was reopened after a while
      let totalCount = 0;
      let totalValue = 0;
      props.ticketEndStates.forEach((ticketEndState) => {
        const begin =
          ticketEndState.get("ticket").get("createdAt")?.getTime() ?? 0;
        const end = ticketEndState.get("updatedAt")?.getTime() ?? 0;
        if (!begin || !end) return;
        totalCount++;
        totalValue += end - begin;
      });
      setMttr(totalCount > 0 ? totalValue / totalCount : 0);
    }
    getMTTR();
  }, [props.ticketEndStates]);

  return (
    <>
      {/* 
// @ts-ignore */}
      <Card variant="outlined">
        <Statistic
          title={t("maintenance:stats.mean_time_to_recovery.statistic.title")}
          value={mttrFormat}
        />
      </Card>
    </>
  );
});
